export const actionTypes: any = {
  GET_SPECIFIC_BENEFIT_MANAGER_START: 'GET_SPECIFIC_BENEFIT_MANAGER_START',
  GET_SPECIFIC_BENEFIT_MANAGER_SUCCESS: 'GET_SPECIFIC_BENEFIT_MANAGER_SUCCESS',
  GET_SPECIFIC_BENEFIT_MANAGER_FINISH: 'GET_SPECIFIC_BENEFIT_MANAGER_FINISH',

  GET_BENEFIT_MANAGER_START: 'GET_BENEFIT_MANAGER_START',
  GET_BENEFIT_MANAGER_SUCCESS: 'GET_BENEFIT_MANAGER_SUCCESS',
  GET_BENEFIT_MANAGER_FINISH: 'GET_BENEFIT_MANAGER_FINISH',

  ADD_BENEFIT_MANAGER_START: 'ADD_BENEFIT_MANAGER_START',
  ADD_BENEFIT_MANAGER_SUCCESS: 'ADD_BENEFIT_MANAGER_SUCCESS',
  ADD_BENEFIT_MANAGER_FINISH: 'ADD_BENEFIT_MANAGER_FINISH',
  ADD_BENEFIT_MANAGER_RESET: 'ADD_BENEFIT_MANAGER_RESET',

  UPDATE_BENEFIT_MANAGER_START: 'UPDATE_BENEFIT_MANAGER_START',
  UPDATE_BENEFIT_MANAGER_SUCCESS: 'UPDATE_BENEFIT_MANAGER_SUCCESS',
  UPDATE_BENEFIT_MANAGER_FINISH: 'UPDATE_BENEFIT_MANAGER_FINISH',
  UPDATE_BENEFIT_MANAGER_RESET: 'UPDATE_BENEFIT_MANAGER_RESET',

  DELETE_BENEFIT_MANAGER_START: 'DELETE_BENEFIT_MANAGER_START',
  DELETE_BENEFIT_MANAGER_SUCCESS: 'DELETE_BENEFIT_MANAGER_SUCCESS',
  DELETE_BENEFIT_MANAGER_FINISH: 'DELETE_BENEFIT_MANAGER_FINISH',

  SINGLE_ACTIVATE_BENEFIT_MANAGER_REQUEST: 'SINGLE_ACTIVATE_BENEFIT_MANAGER_REQUEST',
  SINGLE_ACTIVATE_BENEFIT_MANAGER_SUCCESS: 'SINGLE_ACTIVATE_BENEFIT_MANAGER_SUCCESS',
  SINGLE_ACTIVATE_BENEFIT_MANAGER_FINISH: 'SINGLE_ACTIVATE_BENEFIT_MANAGER_FINISH',

  SINGLE_DEACTIVATE_BENEFIT_MANAGER_REQUEST: 'SINGLE_DEACTIVATE_BENEFIT_MANAGER_REQUEST',
  SINGLE_DEACTIVATE_BENEFIT_MANAGER_SUCCESS: 'SINGLE_DEACTIVATE_BENEFIT_MANAGER_SUCCESS',
  SINGLE_DEACTIVATE_BENEFIT_MANAGER_FINISH: 'SINGLE_DEACTIVATE_BENEFIT_MANAGER_FINISH',

  SORT_BENEFIT_MANAGER_START: 'SORT_BENEFIT_MANAGER_START',
  SORT_BENEFIT_MANAGER_SUCCESS: 'SORT_BENEFIT_MANAGER_SUCCESS',
  SORT_BENEFIT_MANAGER_FINISH: 'SORT_BENEFIT_MANAGER_FINISH',
  SORT_BENEFIT_MANAGER_RESET: 'SORT_BENEFIT_MANAGER_RESET',
}
